import { useSelector, useDispatch } from "react-redux";

import { removeToast, ToastMessage } from "shared/actions/toastActions";

import "./ToastList.scss";

const ToastList = () => {
  const dispatch = useDispatch();
  const toasts = useSelector(({ toasts }: any) => toasts.toasts);

  if (toasts.length === 0) {
    return <></>;
  }

  return (
    <div id="toast-list" className="bottom-right">
      {toasts.map((toast: ToastMessage, i: number) => (
        <div
          className={`alert alert-${toast.kind} alert-dismissible fade show`}
          role="alert"
          key={i}
        >
          <h4 className="alert-heading mb-3">{toast.title}</h4>
          {toast.message && (
            <div className="alert--message">
              {toast.allowHtml ? (
                <div dangerouslySetInnerHTML={{ __html: toast.message }} />
              ) : (
                toast.message
                  ?.split("\\n")
                  .map((s, index) => <span key={index}>{s}</span>)
              )}
            </div>
          )}
          <button
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
              onClick={() => {
                dispatch(removeToast(toast.id));
              }}
            >
              &times;
            </span>
          </button>
        </div>
      ))}
    </div>
  );
};
export default ToastList;
